<app-loading *rxIf="viewModel.isLoading$ | async" [options]="viewModel.loadingOpts$ | async"> </app-loading>

<lib-sticky-modal>
  <lib-sticky-header>
    <div class="modal-header">
      <div class="modal-title">Upload Profile Picture</div>
    </div>
  </lib-sticky-header>
  <lib-sticky-body>
    <div class="pt-16px">
      @if (viewModel.showUploadStatus$ | async) {
        <app-upload-asset-status
          [uploader]="profilePictureUpload"
          [uploadItemState]="viewModel.uploadItemState$ | async"
          [singleInstance]="true"
          [isScrollFocusTarget]="true"
          (replaceFailedUpload)="handleReplaceFailedUpload()"></app-upload-asset-status>
      }

      <app-upload-asset
        #profilePictureUpload
        [parentHandler]="this"
        [showOtherSources]="true"
        [stackOtherSources]="true"
        [allowImage]="true"
        [allowVideo]="false"
        [flattenAnimatedWebPToFirstFrame]="true"
        [hidden]="viewModel.showUploadStatus$ | async"
        [maxAssets]="1">
      </app-upload-asset>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <div class="flex-container flex-space-between flex-row">
      <div>
        <lib-button-destructive
          *rxIf="viewModel?.existingProfilePicture"
          [disabled]="viewModel.deleteProfilePictureDisabled$ | async"
          (buttonClicked)="deleteProfilePicture()">
          Delete Profile Picture
        </lib-button-destructive>
      </div>
      <lib-button-layout>
        <lib-button-neutral (buttonClicked)="cancel()">Cancel</lib-button-neutral>
        <lib-button-primary
          *rxIf="(viewModel.file || viewModel.asset) && !(viewModel.showUploadStatus$ | async)"
          (buttonClicked)="uploadImage()">
          Upload
        </lib-button-primary>
      </lib-button-layout>
    </div>
  </lib-sticky-footer>
</lib-sticky-modal>
